import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';
import { StatusIndicatorListComponent } from './status-indicator-list.component';

@NgModule({
    declarations: [
        StatusIndicatorListComponent
    ],
    entryComponents: [
        StatusIndicatorListComponent
    ],
    exports: [
        StatusIndicatorListComponent
    ],
    imports: [
        CommonModule
    ],
})
export class StatusIndicatorListModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            StatusIndicatorListComponent
        ]);
    }
}
